import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f99141d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "q-pa-lg ecran-container",
  style: {"font-family":"'Roboto', sans-serif"}
}
const _hoisted_2 = { style: {"display":"flex","align-items":"left","justify-content":"left"} }
const _hoisted_3 = {
  key: 0,
  class: "app__page__title__container"
}
const _hoisted_4 = { style: {"white-space":"nowrap","font-size":"2rem"} }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Facturi")
const _hoisted_6 = {
  style: {"font-family":"'Roboto', sans-serif","size":"1.5rem"},
  class: "q-pa-md"
}
const _hoisted_7 = { style: {"padding":"5px"} }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Total rest de plata:  ")
const _hoisted_9 = { style: {"padding":"5px"} }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Scadenta depasita:  ")
const _hoisted_11 = { style: {"color":"red"} }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Sterge filtre! ")
const _hoisted_13 = {
  key: 0,
  class: "q-pa-md"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Download")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "ItemNo:", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Description:", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "ItemNo:", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Description:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_vue_pdf_embed = _resolveComponent("vue-pdf-embed")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_ripple = _resolveDirective("ripple")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.$q.platform.is.desktop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_q_icon, {
                name: "paid",
                style: {"font-size":"2rem","position":"relative","top":"-3px"},
                color: "primary"
              }),
              _hoisted_5
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("b", null, _toDisplayString(_ctx.totalRestDePlata) + " RON", 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("span", _hoisted_11, [
          _createElementVNode("b", null, _toDisplayString(_ctx.totalScadenta) + " RON", 1)
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: "q-pa-md",
      style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'display: flex;flex-direction: column;gap: 2px' : 'display: flex;flex-direction: row;gap: 2px')
    }, [
      _createVNode(_component_q_btn, {
        icon: "restart_alt",
        flat: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refreshFilters()))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tooltip, {
            anchor: "top middle",
            self: "bottom middle",
            offset: [10, 10],
            "transition-show": "scale",
            "transition-hide": "scale"
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_input, {
        outlined: "",
        modelValue: _ctx.filters.id.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.id.value) = $event)),
        label: "Numar Document",
        style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);'),
        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchInvoices()))
      }, null, 8, ["modelValue", "style"]),
      _createVNode(_component_q_input, {
        outlined: "",
        mask: "####-##-##",
        modelValue: _ctx.filters.data.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.data.value) = $event)),
        label: "Data Document",
        style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);'),
        onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.searchInvoices()))
      }, {
        append: _withCtx(() => [
          _createVNode(_component_q_icon, {
            name: "event",
            class: "cursor-pointer"
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_q_popup_proxy, {
            ref: "qDateProxy0",
            "transition-show": "scale",
            "transition-hide": "scale"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_date, {
                modelValue: _ctx.filters.data.value,
                "onUpdate:modelValue": [
                  _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.data.value) = $event)),
                  _cache[4] || (_cache[4] = (val) => _ctx.updateData(val))
                ],
                mask: "YYYY-MM-DD",
                locale: _ctx.myLocale
              }, null, 8, ["modelValue", "locale"])
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      }, 8, ["modelValue", "style"]),
      _createVNode(_component_q_input, {
        outlined: "",
        modelValue: _ctx.filters.valoare.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters.valoare.value) = $event)),
        label: "Valoare",
        style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);'),
        onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.searchInvoices()))
      }, null, 8, ["modelValue", "style"]),
      _createVNode(_component_q_input, {
        outlined: "",
        modelValue: _ctx.filters.moneda.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filters.moneda.value) = $event)),
        label: "Moneda",
        style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);'),
        onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.searchInvoices()))
      }, null, 8, ["modelValue", "style"]),
      _createVNode(_component_q_input, {
        outlined: "",
        mask: "####-##-##",
        modelValue: _ctx.filters.dataScadenta.value,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.filters.dataScadenta.value) = $event)),
        label: "Data Scadenta",
        style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);'),
        onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.searchInvoices()))
      }, {
        append: _withCtx(() => [
          _createVNode(_component_q_icon, {
            name: "event",
            class: "cursor-pointer"
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_q_popup_proxy, {
            ref: "qDateProxy0",
            "transition-show": "scale",
            "transition-hide": "scale"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_date, {
                modelValue: _ctx.filters.dataScadenta.value,
                "onUpdate:modelValue": [
                  _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filters.dataScadenta.value) = $event)),
                  _cache[12] || (_cache[12] = (val) => _ctx.updateDataScadenta(val))
                ],
                mask: "YYYY-MM-DD",
                locale: _ctx.myLocale
              }, null, 8, ["modelValue", "locale"])
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      }, 8, ["modelValue", "style"]),
      _createVNode(_component_q_input, {
        outlined: "",
        modelValue: _ctx.filters.restDeAchitat.value,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.filters.restDeAchitat.value) = $event)),
        label: "Rest De Achitat",
        style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);'),
        onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.searchInvoices()))
      }, null, 8, ["modelValue", "style"]),
      _createVNode(_component_q_input, {
        outlined: "",
        modelValue: _ctx.filters.nrZileDepasireTermenPlata.value,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.filters.nrZileDepasireTermenPlata.value) = $event)),
        label: "Zile Depasire Termen Plata",
        style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);'),
        onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.searchInvoices()))
      }, null, 8, ["modelValue", "style"])
    ], 4),
    (_ctx.existaFacturi)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_component_q_table, {
            grid: _ctx.$q.platform.is.mobile,
            class: "my-sticky-header-table",
            title: "",
            "rows-per-page-options": [0],
            pagination: _ctx.pagination,
            "onUpdate:pagination": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.pagination) = $event)),
            rows: _ctx.invoices,
            columns: _ctx.columns,
            "visible-columns": _ctx.visibleColumns,
            "row-key": "name",
            flat: "",
            bordered: ""
          }, {
            body: _withCtx((props) => [
              _createVNode(_component_q_tr, {
                props: props,
                style: _normalizeStyle({'background-color': props.row.isInvoiceOverdue ? '#DAF3F3':'white'})
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_td, {
                    key: "id",
                    props: props,
                    class: _normalizeClass({'redbold': props.row.isInvoiceOverdue })
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(props.row.id), 1)
                    ]),
                    _: 2
                  }, 1032, ["props", "class"]),
                  _createVNode(_component_q_td, {
                    key: "data",
                    props: props,
                    class: _normalizeClass({'redbold': props.row.isInvoiceOverdue })
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(props.row.data), 1)
                    ]),
                    _: 2
                  }, 1032, ["props", "class"]),
                  _createVNode(_component_q_td, {
                    key: "valoare",
                    props: props,
                    class: _normalizeClass({'redbold': props.row.isInvoiceOverdue })
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(props.row.valoare), 1)
                    ]),
                    _: 2
                  }, 1032, ["props", "class"]),
                  _createVNode(_component_q_td, {
                    key: "moneda",
                    props: props,
                    class: _normalizeClass({'redbold': props.row.isInvoiceOverdue })
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(props.row.moneda), 1)
                    ]),
                    _: 2
                  }, 1032, ["props", "class"]),
                  _createVNode(_component_q_td, {
                    key: "dataScadenta",
                    props: props,
                    class: _normalizeClass({'redbold': props.row.isInvoiceOverdue })
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(props.row.dataScadenta), 1)
                    ]),
                    _: 2
                  }, 1032, ["props", "class"]),
                  _createVNode(_component_q_td, {
                    key: "restDeAchitat",
                    props: props,
                    class: _normalizeClass({'redbold': props.row.isInvoiceOverdue })
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(props.row.restDeAchitat), 1)
                    ]),
                    _: 2
                  }, 1032, ["props", "class"]),
                  _createVNode(_component_q_td, {
                    key: "nrZileDepasireTermenPlata",
                    props: props,
                    class: _normalizeClass({'redbold': props.row.isInvoiceOverdue })
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(props.row.nrZileDepasireTermenPlata), 1)
                    ]),
                    _: 2
                  }, 1032, ["props", "class"]),
                  _createVNode(_component_q_td, {
                    key: "vizualizarePDF",
                    props: props
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_btn, {
                        flat: "",
                        color: "primary",
                        align: "center",
                        icon: "picture_as_pdf",
                        style: {"min-width":"4rem"},
                        onClick: ($event: any) => (_ctx.download_invoice(props.row.id))
                      }, null, 8, ["onClick"])
                    ]),
                    _: 2
                  }, 1032, ["props"]),
                  _createVNode(_component_q_td, {
                    key: "vizualizarePDFCertificate",
                    props: props
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_btn, {
                        flat: "",
                        color: "primary",
                        align: "center",
                        icon: "picture_as_pdf",
                        style: {"min-width":"4rem"},
                        onClick: ($event: any) => (_ctx.download_certificate(props.row.id))
                      }, null, 8, ["onClick"])
                    ]),
                    _: 2
                  }, 1032, ["props"])
                ]),
                _: 2
              }, 1032, ["props", "style"])
            ]),
            item: _withCtx((props) => [
              _createVNode(_component_q_card, {
                class: "my_card_3",
                style: _normalizeStyle({'background-color': props.row.isInvoiceOverdue ? '#DAF3F3':'white'})
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_list, { dense: "" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols.filter(col => { return !col.name.includes('vizualizare')}), (col) => {
                        return (_openBlock(), _createBlock(_component_q_item, {
                          key: col.name
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item_section, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(col.label), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_q_item_section, { side: "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_label, {
                                  class: _normalizeClass({'redbold': props.row.isInvoiceOverdue })
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(col.value), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["class"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_q_card_actions, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_btn, {
                        flat: "",
                        color: "primary",
                        label: "Factura",
                        icon: "picture_as_pdf",
                        onClick: ($event: any) => (_ctx.download_invoice(props.row.id))
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_q_btn, {
                        flat: "",
                        color: "primary",
                        label: "Certificate",
                        icon: "picture_as_pdf",
                        onClick: ($event: any) => (_ctx.download_certificate(props.row.id))
                      }, null, 8, ["onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["style"])
            ]),
            _: 1
          }, 8, ["grid", "pagination", "rows", "columns", "visible-columns"]),
          _createVNode(_component_q_dialog, {
            modelValue: _ctx.fixed,
            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.fixed) = $event)),
            "full-width": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { class: "my_card" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_card_section, { class: "row items-center" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'text-h8' : 'text-h6')
                      }, _toDisplayString(_ctx.popupTitle), 3),
                      (_ctx.$q.platform.is.desktop)
                        ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                            key: 0,
                            "no-caps": "",
                            color: "primary",
                            onClick: _ctx.downloadPDF,
                            icon: "download",
                            style: {"margin-left":"1rem","cursor":"pointer"}
                          }, {
                            default: _withCtx(() => [
                              _hoisted_14
                            ]),
                            _: 1
                          }, 8, ["onClick"])), [
                            [_directive_ripple]
                          ])
                        : _createCommentVNode("", true),
                      (_ctx.$q.platform.is.mobile)
                        ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                            key: 1,
                            "no-caps": "",
                            flat: "",
                            color: "primary",
                            icon: "download",
                            onClick: _ctx.downloadPDF,
                            style: {"cursor":"pointer"}
                          }, null, 8, ["onClick"])), [
                            [_directive_ripple]
                          ])
                        : _createCommentVNode("", true),
                      _createVNode(_component_q_space),
                      (_ctx.isLoadingInvoice)
                        ? (_openBlock(), _createBlock(_component_q_spinner, {
                            key: 2,
                            color: "black",
                            size: _ctx.$q.platform.is.mobile ? '1.5em' : '3em'
                          }, null, 8, ["size"]))
                        : _createCommentVNode("", true),
                      (_ctx.isLoadingInvoice)
                        ? (_openBlock(), _createBlock(_component_q_space, { key: 3 }))
                        : _createCommentVNode("", true),
                      (_ctx.$q.platform.is.desktop)
                        ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                            key: 4,
                            icon: "close",
                            flat: "",
                            round: "",
                            dense: ""
                          }, null, 512)), [
                            [_directive_close_popup]
                          ])
                        : _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                            key: 5,
                            icon: "close",
                            flat: "",
                            round: "",
                            dense: "",
                            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.widthPdf=300))
                          }, null, 512)), [
                            [_directive_close_popup]
                          ])
                    ]),
                    _: 1
                  }),
                  (_ctx.$q.platform.is.mobile)
                    ? (_openBlock(), _createBlock(_component_q_card_section, {
                        key: 0,
                        class: "my_card_2"
                      }, {
                        default: _withCtx(() => [
                          (!_ctx.isLoadingInvoice)
                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                key: 0,
                                onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.changeWitdhPdf('in'))),
                                icon: "zoom_in",
                                style: {"margin-bottom":"8px"}
                              }))
                            : _createCommentVNode("", true),
                          (!_ctx.isLoadingInvoice)
                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                key: 1,
                                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.changeWitdhPdf('out'))),
                                icon: "zoom_out",
                                style: {"margin-left":"10px","margin-bottom":"8px"}
                              }))
                            : _createCommentVNode("", true),
                          _hoisted_15,
                          _createVNode(_component_vue_pdf_embed, {
                            source: _ctx.pdfBase64,
                            width: _ctx.widthPdf
                          }, null, 8, ["source", "width"])
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_q_card_section, {
                        key: 1,
                        class: "my_card_2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_vue_pdf_embed, { source: _ctx.pdfBase64 }, null, 8, ["source"])
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_q_dialog, {
            modelValue: _ctx.areMoreCertificates,
            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.areMoreCertificates) = $event)),
            maximized: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { class: "my_card_5" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_card_section, { class: "row items-center" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'text-h8' : 'text-h6')
                      }, "Certificate Factura " + _toDisplayString(_ctx.selectedBillNr), 3),
                      _createVNode(_component_q_space),
                      _withDirectives(_createVNode(_component_q_btn, {
                        icon: "close",
                        flat: "",
                        round: "",
                        dense: ""
                      }, null, 512), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_list, { dense: "" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.certificates, (certificat, index) => {
                            return (_openBlock(), _createBlock(_component_q_item, {
                              key: certificat.ItemNo
                            }, {
                              default: _withCtx(() => [
                                (_ctx.$q.platform.is.mobile)
                                  ? (_openBlock(), _createBlock(_component_q_card, {
                                      key: 0,
                                      class: "my_card_4"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_item_section, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_item_label, null, {
                                              default: _withCtx(() => [
                                                _hoisted_16
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_q_item_section, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_item_label, { caption: "" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(certificat.ItemNo), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _hoisted_17,
                                        _createVNode(_component_q_item_section, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_item_label, null, {
                                              default: _withCtx(() => [
                                                _hoisted_18
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_q_item_section, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_item_label, { caption: "" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(certificat.Description), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_q_card_actions, { vertical: "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_btn, {
                                              flat: "",
                                              color: "primary",
                                              icon: "picture_as_pdf",
                                              onClick: ($event: any) => (_ctx.download_certificate_2(index))
                                            }, null, 8, ["onClick"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true),
                                (_ctx.$q.platform.is.desktop)
                                  ? (_openBlock(), _createBlock(_component_q_item_section, {
                                      key: 1,
                                      "no-wrap": ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_item_label, null, {
                                          default: _withCtx(() => [
                                            _hoisted_19,
                                            _createTextVNode(" " + _toDisplayString(certificat.ItemNo), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true),
                                (_ctx.$q.platform.is.desktop)
                                  ? (_openBlock(), _createBlock(_component_q_item_section, {
                                      key: 2,
                                      "no-wrap": ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_item_label, null, {
                                          default: _withCtx(() => [
                                            _hoisted_20,
                                            _createTextVNode(" " + _toDisplayString(certificat.Description), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true),
                                (_ctx.$q.platform.is.desktop)
                                  ? (_openBlock(), _createBlock(_component_q_item_section, {
                                      key: 3,
                                      class: "pdf_icon"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_btn, {
                                          flat: "",
                                          color: "primary",
                                          icon: "picture_as_pdf",
                                          onClick: ($event: any) => (_ctx.download_certificate_2(index))
                                        }, null, 8, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true)
  ]))
}